import { http } from './http';
import { AuthUser } from '../types';

export interface TokenPair {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
}

export interface LoginResponse {
  user: AuthUser;
  tokens: TokenPair;
}

interface StartRdvOauthResponse {
  authorizationUrl: string;
}

export const authApi = {
  async register(payload: { email: string; password: string; firstName: string; lastName: string; schoolName: string }): Promise<LoginResponse> {
    const { data } = await http.post<LoginResponse>('/v1/auth/register', payload);
    return data;
  },
  async login(credentials: {
    email: string;
    password: string;
  }): Promise<LoginResponse> {
    const { data } = await http.post<LoginResponse>(
      '/v1/auth/login',
      credentials,
    );
    return data;
  },
  async fetchProfile(): Promise<AuthUser> {
    const { data } = await http.get<AuthUser>('/v1/auth/me');
    return data;
  },
  async startRdvOauthLogin(payload?: {
    redirectUri?: string;
  }): Promise<StartRdvOauthResponse> {
    const { data } = await http.post<StartRdvOauthResponse>(
      '/v1/integrations/rdv/oauth/start/login',
      payload ?? {},
    );
    return data;
  },
  async consumeRdvOauthLoginTicket(token: string): Promise<LoginResponse> {
    const { data } = await http.get<LoginResponse>(
      `/v1/integrations/rdv/oauth/login-ticket?token=${encodeURIComponent(
        token,
      )}`,
    );
    return data;
  },
  async refresh(refreshToken: string): Promise<TokenPair> {
    const { data } = await http.post<TokenPair>('/v1/auth/refresh', {
      refreshToken,
    }, { timeout: 15000 });
    return data;
  },
  async logout(refreshToken: string, accessToken?: string | null): Promise<void> {
    await http.post('/v1/auth/logout', { refreshToken }, { timeout: 15000, headers: accessToken ? { Authorization: 'Bearer ' + accessToken } : undefined });
  },
  async invite(payload: {
    email: string;
    password?: string;
    firstName: string;
    lastName: string;
    phoneNumber?: string;
    role: string;
  }): Promise<{ id: string; email: string; invitationSent?: boolean }> {
    // `invitationSent` : compte créé sans mot de passe, le lien pour le choisir est parti (J1).
    const { data } = await http.post<{ id: string; email: string; invitationSent?: boolean }>(
      '/v1/auth/invite',
      payload,
    );
    return data;
  },
};
